import React, { memo, useEffect, useState } from "react"
import Link from "next/link"
import CardTopic from "components/CardTopic"
import TypeEvent from "utils/TypeEvent"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"

// eslint-disable-next-line react/display-name
const MySwiper = memo((props) => {
  const { name, events, id, type_block, display_type } = props
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <>
      <Link href={`/danh-muc/${id}`}>
        <div className="w-full flex items-center wapper_see_more justify-between max-lg:mr-4 mr-8 mb-5 max-sm:mb-3">
          <span className="max-sm:text-base max-sm:leading-[22px] text-xl font-semibold text-white">{name}</span>
          <div className={`flex items-center gap-[10px] text-primary text-xs sm:text-sm font-normal whitespace-nowrap`}>
            Xem thêm
          </div>
        </div>
      </Link>
      {isMobile ? (
        <div className="flex flex-col gap-3 items-center max-md:pr-4">
          {events?.slice(0, 3).map((item) => (
            <CardTopic key={item.id} {...item} display_type={display_type} hideText={false} />
          ))}
        </div>
      ) : (
        <Swiper
          key={"topic"}
          slidesPerView={3.2}
          slidesPerGroup={2}
          spaceBetween={24}
          modules={[Navigation]}
          className="mySwiper"
          navigation={true}
          breakpoints={{
            640: {
              slidesPerView: 1.5,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            740: {
              slidesPerView: 1.53,
              slidesPerGroup: 1
            },
            800: {
              slidesPerView: 1.7,
              slidesPerGroup: 1
            },
            845: {
              slidesPerView: 1.9,
              slidesPerGroup: 1
            },
            955: {
              slidesPerView: 2.1,
              slidesPerGroup: 1
            },
            1070: {
              slidesPerView: 2.3,
              slidesPerGroup: 2
            },
            1170: {
              slidesPerView: 2.4,
              slidesPerGroup: 2
            },
            1200: {
              slidesPerView: 2.1,
              slidesPerGroup: 2
            },
            1370: {
              slidesPerView: 2.3,
              slidesPerGroup: 2
            },
            1460: {
              slidesPerView: 2.5,
              slidesPerGroup: 2
            },
            1550: {
              slidesPerView: 2.7,
              slidesPerGroup: 2
            },
            1680: {
              slidesPerView: 2.9,
              slidesPerGroup: 2
            },
            1760: {
              slidesPerView: 3.2,
              slidesPerGroup: 3
            }
          }}
        >
          {events?.length > 0 &&
            events?.map((item) => {
              const { id } = item

              return (
                <SwiperSlide key={id} className="slide-topic">
                  {type_block === TypeEvent.TOPIC && (
                    <CardTopic {...item} display_type={display_type} hideText={false} />
                  )}
                </SwiperSlide>
              )
            })}
        </Swiper>
      )}
    </>
  )
})

export default MySwiper
